/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:57 PM
 *
 */

/**
 * Check if given url is valid or not using URL Object
 * @param {string} string The given string to be checked.
 * @return {boolean} Returns true if string is a valid URL or vice-versa
 */
export function isValidHttpUrl(string: string) {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
}
